import { Grid } from '@mui/material';
import { memo } from 'react';
import PmiTextField from 'shell/components/shared/text-field';
import { DatePicker } from '@mui/lab';
import { PmiButton } from 'shell/components/shared/button';
import { AccordionFamilyCoexistence as AccordionFamilyCoexistenceVM } from 'shell/view-models/accordion-family-coexistence';
import CohabitationBondList from 'shell/components/shared/cohabitation-bond-list';
import { FormikErrors, FormikTouched } from 'formik';
import PmiDatePicker from 'shell/components/shared/date-picker';

interface FamilyCoexistenceProps {
  disabled?: boolean;
  isCohabitation?: boolean;
  values?: AccordionFamilyCoexistenceVM;
  errors?: FormikErrors<AccordionFamilyCoexistenceVM>;
  touched?: FormikTouched<AccordionFamilyCoexistenceVM>;
  onChange: (
    key: keyof AccordionFamilyCoexistenceVM,
    value: AccordionFamilyCoexistenceVM[keyof AccordionFamilyCoexistenceVM]
  ) => void;
  resetForm: () => void;
}

const FamilyCoexistenceFormComponent = ({
  disabled,
  values,
  errors,
  touched,
  onChange,
  resetForm,
}: FamilyCoexistenceProps): React.ReactElement => {
  return (
    <Grid container spacing={1}>
      <Grid item xs={12} md={4}>
        <PmiDatePicker
          label="Data decorrenza appartenenza *"
          value={values?.membershipDate || null}
          disabled={disabled}
          onChange={(value) => {
            onChange('membershipDate', value || null);
          }}
          renderInput={(params) => (
            <PmiTextField
              {...params}
              id="membershipDate"
              fullWidth
              error={touched?.membershipDate && Boolean(errors?.membershipDate)}
              helperText={errors?.membershipDate}
            />
          )}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <DatePicker
          label="Data decorrenza legame *"
          value={values?.bondDate || null}
          disabled={disabled}
          onChange={(value) => {
            onChange('bondDate', value || null);
          }}
          renderInput={(params) => (
            <PmiTextField
              {...params}
              id="bondDate"
              fullWidth
              error={touched?.bondDate && Boolean(errors?.bondDate)}
              helperText={errors?.bondDate}
            />
          )}
        />
      </Grid>
      <Grid
        container
        item
        spacing={0}
        rowSpacing={{ xs: 1, md: 0 }}
        columnSpacing={{ xs: 0, md: 1 }}
        xs={12}
      >
        <Grid item xs={12} md={4}>
          <CohabitationBondList
            label="Legame convivenza *"
            aria-label="Legame convivenza"
            id="coexistence-bond"
            onChange={(value) => {
              onChange('coexistenceBond', value);
            }}
            value={values?.coexistenceBond || ''}
            error={touched?.coexistenceBond && Boolean(errors?.coexistenceBond)}
            disabled={disabled}
          />
        </Grid>
      </Grid>
      <Grid container item spacing={2} xs={12}>
        <Grid item xs={12} md={2}>
          <PmiButton
            color="cdmBrandThird"
            variant="outlined"
            fullWidth
            onClick={resetForm}
            disabled={disabled}
          >
            Ripulisci
          </PmiButton>
        </Grid>
      </Grid>
    </Grid>
  );
};

FamilyCoexistenceFormComponent.displayName = 'Family Coexistence Form component';

const FamilyCoexistenceForm = memo(FamilyCoexistenceFormComponent);

export default FamilyCoexistenceForm;
